module.exports = __webpack_public_path__ + "img/activ-img1.3d436276.jpg";